/* Footer link "Cookie-Einstellungen": opens the preferences dialog of the Shopify cookie banner. */
(function () {
  function showPreferences() {
    var banner = window.privacyBanner;
    if (banner && typeof banner.showPreferences === 'function') banner.showPreferences();
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('a[href$="#cookie-einstellungen"]') : null;
    if (!link) return;
    event.preventDefault();
    var shopify = window.Shopify || {};
    if (shopify.customerPrivacy) {
      showPreferences();
    } else if (typeof shopify.loadFeatures === 'function') {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) showPreferences();
      });
    }
  });
})();
